<app-modal-shell [showClose]="false">
  <h1 modalTitle>{{ 'employeeV2.welcome.title' | translate }}</h1>
  <div class="welcome">
    <p>{{ 'employeeV2.welcome.description' | translate }}</p>
    <ion-button fill="clear" (click)="showLegal('terms')">{{ 'employeeV2.welcome.terms' | translate }}</ion-button>
    <ion-button fill="clear" (click)="showLegal('privacy')">{{ 'employeeV2.welcome.privacy' | translate }}</ion-button>
    <ion-checkbox [checked]="accepted()" [disabled]="saving()" (ionChange)="accepted.set($event.detail.checked)">{{ 'employeeV2.welcome.accept' | translate }}</ion-checkbox>
    @if (error()) { <p role="alert">{{ 'employeeV2.welcome.error' | translate }}</p> }
    <ion-button expand="block" [disabled]="!accepted() || saving()" (click)="continue()">{{ 'employeeV2.welcome.start' | translate }}</ion-button>
  </div>
</app-modal-shell>
